import { Injectable, signal } from '@angular/core';
import { getDefaultIsDummy } from './unpaid-payments-route-query.util';

const STORAGE_KEY = 'is_dummy';

@Injectable({
  providedIn: 'root',
})
export class UnpaidPaymentsIsDummyService {
  readonly isDummy = signal(this.readStoredBoolean());

  constructor() {
    this.ensureStorageInitialized();
  }

  getStorageValue(): string {
    return this.isDummy() ? '1' : '0';
  }

  /** Sync from URL route state without navigation side effects. */
  syncFromRoute(value: boolean): void {
    if (this.isDummy() === value) return;
    this.persist(value);
    this.isDummy.set(value);
  }

  private ensureStorageInitialized(): void {
    const stored = sessionStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(STORAGE_KEY);
    if (stored === null) {
      const defaultValue = getDefaultIsDummy();
      this.persist(defaultValue);
      this.isDummy.set(defaultValue);
    }
  }

  private readStoredBoolean(): boolean {
    const stored = sessionStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(STORAGE_KEY);
    if (stored === '1') return true;
    if (stored === '0') return false;
    return getDefaultIsDummy();
  }

  private persist(value: boolean): void {
    const str = value ? '1' : '0';
    localStorage.setItem(STORAGE_KEY, str);
    sessionStorage.setItem(STORAGE_KEY, str);
  }
}
